import { useIsMobile } from "../../../hooks";
import { SegmentControl } from "../../../SegmentControl";
import { useClientTradingReportContext } from "../providers/TradingReportProvider";
import { useClientTypeTabsTranslate } from "./useClientTypeTabsTranslate";

export type ClientTypeTab = "direct" | "indirect";

export type ClientTypeTabsProps = {
  value: ClientTypeTab;
  onChange: (tab: ClientTypeTab) => void;
};

export const ClientTypeTabs = ({ value, onChange }: ClientTypeTabsProps) => {
  const translations = useClientTypeTabsTranslate();
  const { actions } = useClientTradingReportContext();
  const isMobile = useIsMobile();

  return (
    <SegmentControl<ClientTypeTab>
      fullWidth={isMobile}
      options={[
        { label: translations.yourClients, value: "direct" },
        { label: translations.sharedWithYou, value: "indirect" },
      ]}
      value={value}
      onChange={(tab) => {
        actions.setPage(0);
        onChange(tab);
      }}
      aria-label="Trading report client view"
      data-testid="client_trading_report_client_type_tabs"
    />
  );
};
